<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="prohibited_h4_1[getCurrentLocale]"></h4>
                            <h5 v-html="prohibited_h5_1[getCurrentLocale]"></h5>
                            <br /><p v-html="prohibited_p_1[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_1[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_2[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_3[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_4[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_5[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_6[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_7[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><br /><h4 v-html="prohibited_h4_2[getCurrentLocale]"></h4>
                            <h5 v-html="prohibited_h5_2[getCurrentLocale]"></h5>
                            <p v-html="prohibited_p_2[getCurrentLocale]"></p>
                            <p v-html="prohibited_p_3[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_8[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_9[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_10[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_11[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_12[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_13[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_14[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_15[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><p v-html="prohibited_p_4[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_16[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_17[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_18[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><p v-html="prohibited_p_5[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_19[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_20[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_21[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_22[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_23[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_24[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_25[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_26[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><p v-html="prohibited_p_6[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_27[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_28[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_29[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_30[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_31[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_32[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><p v-html="prohibited_p_7[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_33[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_34[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_35[getCurrentLocale]"></li>
                            </ul>


                            <br /><br /><p v-html="prohibited_p_8[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="prohibited_li_36[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_37[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_38[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_39[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_40[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_41[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_42[getCurrentLocale]"></li>
                                <li v-html="prohibited_li_43[getCurrentLocale]"></li>
                            </ul>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Prohibited Items',
                    de: 'Verbotene Gegenstände',
                },
                // >>> ------------------------
               prohibited_h4_1 : {
                    en: 'Hold baggage (acc. to EU Regulation 2015/1998 Annex 5B)',
                    de: 'Aufgegebenes Gepäck (gem. EU VO 2015/1998 Anlage 5B)',
                },
                prohibited_h5_1 : {
                    en: 'List of prohibited articles',
                    de: 'Liste der verbotenen Gegenstände',
                },
                prohibited_h4_2 : {
                    en: 'Carry on baggage (acc. to EU Regulation 2015/1998 Annex 4C)',
                    de: 'Handgepäck (gem. EU VO 2015/1998 Anlage 4C))',
                },
                prohibited_h5_2 : {
                    en: 'List of prohibited articles',
                    de: 'Liste der verbotenen Gegenstände',
                },
                // >>> ------------------------
                prohibited_p_1: {
                    en: 'Passengers are not permitted to carry the following articles in their hold baggage: explosives and incendiary substances and devices — explosives and incendiary substances and devices capable of being used to cause serious injury or to pose a threat to the safety of aircraft, including: ',
                    de: 'Die nachfolgend aufgeführten Gegenstände dürfen von Fluggästen nicht im aufgegebenen Gepäck mitgeführt werden.',
                },
                prohibited_li_1: {
                    en: 'Ammunition,',
                    de: 'Munition,',
                },
                prohibited_li_2: {
                    en: 'blasting caps,',
                    de: 'Sprengkapseln',
                },
                prohibited_li_3: {
                    en: 'detonators and fuses,',
                    de: 'Detonatoren und Zünder,',
                },
                prohibited_li_4: {
                    en: 'mines, grenades and other explosive military stores,',
                    de: 'Minen, Granaten oder andere militärische Sprengkörper,',
                },
                prohibited_li_5: {
                    en: 'fireworks and other pyrotechnics,',
                    de: 'Feuerwerkskörper und andere pyrotechnische Erzeugnisse,',
                },
                prohibited_li_6: {
                    en: 'smoke-generating canisters and smoke-generating cartridges,',
                    de: 'Rauchkanister und Rauchpatronen,',
                },
                prohibited_li_7: {
                    en: 'dynamite, gunpowder and plastic explosives',
                    de: 'Dynamit, Schießpulver und Plastiksprengstoffe',
                },
                // >>> ------------------------
                prohibited_p_2: {
                    en: 'Without prejudice to applicable safety rules, passengers are not permitted to carry the following articles into security restricted areas or on board an aircraft: ',
                    de: 'Unbeschadet der geltenden Sicherheitsvorschriften dürfen folgende Gegenstände von Fluggästen nicht in Sicherheitsbereiche oder an Bord eines Luftfahrzeugs mitgenommen werden:',
                },
                prohibited_p_3: {
                    en: 'a) <i>guns, firearms or any other devices that discharge projectiles</i> — devices capable, or appearing capable, of being used to cause serious injury by discharging a projectile, including: ',
                    de: 'a) <i>Gewehre, Feuerwaffen und sonstige Geräte, die zum Abschießen von Projektilen bestimmt sind</i> - Geräte, die in der Lage sind oder zu sein scheinen, durch Abschießen eines Projektils schwere Verletzungen herbeizuführen, einschließlich:',
                },
                prohibited_li_8: {
                    en: 'firearms of all types, such as pistols, revolvers, rifles, shotguns, ',
                    de: 'Feuerwaffen aller Art, wie Pistolen, Revolver, Gewehre, Flinten,'
                },
                prohibited_li_9: {
                    en: 'toy guns, replicas and imitation firearms capable of being mistaken for real weapons,',
                    de: 'Spielzeugwaffen, Nachbildungen und Imitationen von Feuerwaffen, die mit echten Waffen verwechselt werden können,'
                },
                prohibited_li_10: {
                    en: 'component parts of firearms, excluding telescopic sights, ',
                    de: 'Teile von Feuerwaffen, ausgenommen Zielfernrohre,'
                },
                prohibited_li_11: {
                    en: 'compressed air and CO2 guns, such as pistols, pellet guns, rifles and ball bearing guns,',
                    de: 'Luftdruck- und CO2-Waffen, wie Luft-, Feder- und Pelletpistolen und -gewehre oder sogenannte „Ball Bearing Guns“ (BB Guns),'
                },
                prohibited_li_12: {
                    en: 'signal flare pistols and starter pistols, ',
                    de: 'Signalpistolen und Startpistolen,'
                },
                prohibited_li_13: {
                    en: 'bows, cross bows and arrows,',
                    de: 'Bogen, Armbrüste und Pfeile,'
                },
                prohibited_li_14: {
                    en: 'harpoon guns and spear guns, ',
                    de: 'Abschussgeräte für Harpunen und Speere,'
                },
                prohibited_li_15: {
                    en: 'slingshots and catapults',
                    de: 'Schleudern und Katapulte'
                },
                // >>> ------------------------
                prohibited_p_4: {
                    en: 'b) <i>stunning devices</i> — devices designed specifically to stun or immobilize, including: ',
                    de: 'b) <i>Betäubungsgeräte</i> - Geräte, die speziell dazu bestimmt sind, eine Betäubung oder Bewegungsunfähigkeit zu bewirken, einschließlich:',
                },
               prohibited_li_16: {
                    en: 'devices for shocking, such as stun guns, tasers and stun batons,',
                    de: 'Gegenstände zur Schockbetäubung, wie Betäubungsgewehre, Taser und Betäubungsstäbe,'
                },
               prohibited_li_17: {
                    en: 'animal stunners and animal killers, ',
                    de: 'Apparate zur Viehbetäubung und Viehtötung,'
                },
               prohibited_li_18: {
                    en: 'disabling and incapacitating chemicals, gases and sprays, such as mace, pepper sprays, capsicum sprays, tear gas, acid sprays and animal repellent sprays',
                    de: 'Handlungsunfähig machende und die Handlungsfähigkeit herabsetzende Chemikalien, Gase und Sprays, wie Reizgas, Pfeffersprays, Capsicum-Sprays, Tränengas, Säuresprays und Tierabwehrsprays'
                },
                // >>> ------------------------
                prohibited_p_5: {
                    en: 'c)  <i>objects with a sharp point or sharp edge</i> — objects with a sharp point or sharp edge capable of being used to cause serious injury, including:',
                    de: 'c) <i>spitze oder scharfe Gegenstände</i> - spitze oder scharfe Gegenstände, mit denen schwere Verletzungen herbeigeführt werden können, einschließlich:',
                },
                prohibited_li_19: {
                    en: 'items designed for chopping, such as axes, hatchets and cleavers,',
                    de: 'Hackwerkzeuge, wie Äxte, Beile und Hackmesser,',
                },
                prohibited_li_20: {
                    en: 'ice axes and ice picks,',
                    de: 'Eisäxte und Eispickel,',
                },
                prohibited_li_21: {
                    en: 'razor blades,',
                    de: 'Rasierklingen,',
                },
                prohibited_li_22: {
                    en: 'box cutters,',
                    de: 'Teppichmesser,',
                },
                prohibited_li_23: {
                    en: 'knives with blades of more than 6 cm,',
                    de: 'Messer mit einer Klingenlänge über 6 cm,',
                },
                prohibited_li_24: {
                    en: 'scissors with blades of more than 6 cm as measured from the fulcrum, ',
                    de: 'Scheren mit einer Klingenlänge über 6 cm ab dem Scharnier gemessen,',
                },
                prohibited_li_25: {
                    en: 'martial arts equipment with a sharp point or sharp edge,',
                    de: 'Kampfsportgeräte mit einer Spitze oder scharfen Kante,',
                },
                prohibited_li_26: {
                    en: 'swords and sabres',
                    de: 'Schwerter und Säbel',
                },
                // >>> ------------------------
                prohibited_p_6: {
                    en: "d) <i>workmen's tools</i> — tools capable of being used either to cause serious injury or to threaten the safety of aircraft, including: ",
                    de: 'd) <i>Werkzeuge</i> - Werkzeuge, mit denen schwere Verletzungen herbeigeführt werden können oder die Sicherheit des Luftfahrzeugs gefährdet werden kann, einschließlich:',
                },
                prohibited_li_27: {
                    en: 'crowbars,',
                    de: 'Brecheisen,',
                },
                prohibited_li_28: {
                    en: 'drills and drill bits, including cordless portable power drills, ',
                    de: 'Bohrmaschinen und Bohrer, einschließlich tragbare Akkubohrmaschinen,',
                },
                prohibited_li_29: {
                    en: 'tools with a blade or a shaft of more than 6 cm capable of use as a weapon, such as screwdrivers and chisels, ',
                    de: 'Werkzeuge mit einer Klinge oder einem Schaft von über 6 cm Länge, die als Waffe verwendet werden können, wie Schraubendreher und Meißel,',
                },
                prohibited_li_30: {
                    en: 'saws, including cordless portable power saws,',
                    de: 'Sägen, einschließlich tragbare Akkusägen,',
                },
                prohibited_li_31: {
                    en: 'blowtorches,',
                    de: 'Lötlampen,',
                },
                prohibited_li_32: {
                    en: 'bolt guns and nail guns',
                    de: 'Bolzenschussgeräte und Druckluftnagler',
                },
                // >>> ------------------------
                prohibited_p_7: {
                    en: 'e) <i>blunt instruments</i> — objects capable of being used to cause serious injury when used to hit, including: ',
                    de: 'e) <i>stumpfe Gegenstände</i> - Gegenstände, mit denen, wenn sie als Schlagwaffe eingesetzt werden, schwere Verletzungen herbeigeführt werden können, einschließlich:',
                },
                prohibited_li_33: {
                    en: 'baseball and softball bats,',
                    de: 'Baseball- und Softballschläger,',
                },
                prohibited_li_34: {
                    en: 'clubs and batons, such as billy clubs, blackjacks and night sticks,',
                    de: 'Knüppel und Schlagstöcke, wie Totschläger,',
                },
                prohibited_li_35: {
                    en: 'martial arts equipment',
                    de: 'Kampfsportgeräte',
                },
                // >>> ------------------------
                prohibited_p_8: {
                    en: 'f) <i>explosives and incendiary substances and devices</i> — explosives and incendiary substances and devices capable, or appearing capable, of being used to cause serious injury or to pose a threat to the safety of aircraft, including: ',
                    de: 'f) <i>Spreng- und Brandstoffe sowie Spreng- und Brandsätze</i> - Spreng- und Brandstoffe sowie Spreng- und Brandsätze, die in der Lage sind oder zu sein scheinen, schwere Verletzungen herbeizuführen oder die Sicherheit des Luftfahrzeugs zu gefährden, einschließlich:',
                },
                prohibited_li_36: {
                    en: 'ammunition',
                    de: 'Munition,',
                },
                prohibited_li_37: {
                    en: 'blasting caps,',
                    de: 'Sprengkapseln,',
                },
                prohibited_li_38: {
                    en: 'detonators and fuses,',
                    de: 'Detonatoren und Zünder,',
                },
                prohibited_li_39: {
                    en: 'replica or imitation explosive devices,',
                    de: 'Nachbildungen oder Imitationen von Sprengkörpern,',
                },
                prohibited_li_40: {
                    en: 'mines, grenades and other explosive military stores,',
                    de: 'Minen, Granaten oder andere militärische Sprengkörper,',
                },
                prohibited_li_41: {
                    en: 'fireworks and other pyrotechnics,',
                    de: 'Feuerwerkskörper und andere pyrotechnische Erzeugnisse,',
                },
                prohibited_li_42: {
                    en: 'smoke-generating canisters and smoke-generating cartridges,',
                    de: 'Rauchkanister und Rauchpatronen,',
                },
                prohibited_li_43: {
                    en: 'dynamite, gunpowder and plastic explosives',
                    de: 'Dynamit, Schießpulver und Plastiksprengstoffe',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }




    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/prohibited-items/Home.vue